import axiosInstance from "../utils/axios";

export const ProfileImageDetailService = async (values) => {
  return await axiosInstance().post(`/updateProfileImage`, values);
};

export const RemoveProfileImage = async (values) => {
  return await axiosInstance().post(`/removeProfileImage`, values);
};

export const LogoutService = async () => {
  return await axiosInstance().get(`/logout`);
};
